<template>
  <header class="header-subsection animate__animated animate__fadeInDown" :style="headerStyle">
    <div class="navigation-bar" :style="navigationStyle">
      <img
        class="image"
        alt="Image"
        :src="logoSrc"
      />
      <button class="menu-toggle" type="button" aria-label="打开导航" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <nav class="navbar" :class="{ open: openMenu }" ref="navbar" aria-label="主导航">
        <router-link
          class="text-wrapper"
          v-for="(item, i) in items"
          :key="item.path"
          ref="navItem"
          :class="{ active: activeIndex === i }"
          :to="item.path"
          @click.native="closeMenu"
        >
          {{ item.label }}
        </router-link>
        <div
          class="indicator"
          :style="{ left: indicatorLeft + 'px', width: indicatorWidth + 'px' }"
        ></div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderSubsection",
  props: { fixed: { type: Boolean, default: false }, logoSrc: { type: String, default: "/static/img/image-506@2x.png" } },
  data() {
    return {
      items: [
        { label: "首页", path: "/" },
        { label: "关于云帆", path: "/about" },
        { label: "课程体系", path: "/course" },
        { label: "云帆公告", path: "/pub" },
        { label: "招贤纳士", path: "/zhaoping" },
      ],
      activeIndex: 0,
      indicatorLeft: 0,
      indicatorWidth: 30,
      openMenu: false,
    };
  },
  computed: {
    headerStyle() {
      return this.fixed ? { width: "1920px", left: "calc(50% - 960px)" } : {};
    },
    navigationStyle() {
      return this.fixed
        ? { width: "1920px", padding: "0 180px" }
        : { width: "100%", padding: "0 180px" };
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIndicator);
    window.removeEventListener("resize", this.closeOnWide);
  },
  watch: {
    $route: {
      handler() {
        this.syncActiveRoute();
        this.$nextTick(this.updateIndicator);
      },
      immediate: false,
    },
  },
  methods: {
    updateIndicator() {
      const items = this.$refs.navItem || [];
      const active = items[this.activeIndex];
      const navbar = this.$refs.navbar;
      const activeEl = active && active.$el ? active.$el : active;
      if (activeEl && navbar) {
        this.indicatorLeft = activeEl.offsetLeft;
        this.indicatorWidth = activeEl.offsetWidth;
      }
    },
    syncActiveRoute() {
      const path = this.$route ? this.$route.path || "/" : "/";
      const exactIndex = this.items.findIndex((item) => item.path === path);
      if (exactIndex >= 0) {
        this.activeIndex = exactIndex;
        return;
      }
      const sectionIndex = this.items.findIndex((item) => item.path !== "/" && path.startsWith(item.path));
      this.activeIndex = sectionIndex >= 0 ? sectionIndex : 0;
    },
    toggleMenu() {
      this.openMenu = !this.openMenu;
      this.$nextTick(this.updateIndicator);
    },
    closeMenu() {
      this.openMenu = false;
      this.$nextTick(this.updateIndicator);
    },
    closeOnWide() {
      if (window.innerWidth > 992 && this.openMenu) {
        this.closeMenu();
      }
    },
  },
  mounted() {
    this.syncActiveRoute();
    this.$nextTick(this.updateIndicator);
    window.addEventListener("resize", this.updateIndicator);
    window.addEventListener("resize", this.closeOnWide);
  },
};
</script>


<style scoped>
.header-subsection {
  align-items: center;
  background-color: transparent;
  display: flex;
  height: 99px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.header-subsection .navigation-bar {
  -webkit-backdrop-filter: blur(8px) brightness(100%);
  backdrop-filter: blur(8px) brightness(100%);
  background: linear-gradient(
    180deg,
    rgba(5, 108, 162, 1) 0%,
    rgba(3, 146, 221, 0) 100%
  );
  height: 99px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 180px;
}

.header-subsection .navbar {
  align-items: center;
  display: inline-flex;
  gap: 64px;
  position: relative;
}

.header-subsection .menu-toggle {
  display: none;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  cursor: pointer;
  padding: 8px;
}

.header-subsection .menu-toggle span {
  background: #ffffff;
  border-radius: 2px;
  display: block;
  height: 2px;
  margin: 4px 0;
  width: 20px;
}

.header-subsection .text-wrapper {
  color: #ffffff;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 27px;
  margin-top: -1.00px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
  cursor: pointer;
  text-decoration: none;
}

.header-subsection .text-wrapper.active {
  color: #4ad7ff;
}

.header-subsection .image {
  aspect-ratio: 2.6;
  height: 64px;
  object-fit: cover;
  width: 167px;
}

.header-subsection .indicator {
  position: absolute;
  bottom: 0;
  height: 3px;
  border-radius: 2px;
  background: linear-gradient(90deg, #4ad7ff 0%, #3aa0ff 100%);
  box-shadow: 0 0 6px rgba(58, 160, 255, 0.6);
  transition: left 200ms ease, width 200ms ease;
}

@media (max-width: 992px) {
  .header-subsection {
    height: 72px;
  }

  .header-subsection .navigation-bar {
    height: 72px;
    padding: 0 24px !important;
  }

  .header-subsection .image {
    height: 44px;
    width: 115px;
  }

  .header-subsection .menu-toggle {
    display: block;
  }

  .header-subsection .navbar {
    align-items: stretch;
    background: rgba(0, 24, 60, 0.92);
    border-radius: 8px;
    box-shadow: 0 12px 30px rgba(0, 24, 60, 0.18);
    display: none;
    flex-direction: column;
    gap: 0;
    padding: 10px 0;
    position: absolute;
    right: 24px;
    top: 62px;
    width: 156px;
    z-index: 10;
  }

  .header-subsection .navbar.open {
    display: flex;
  }

  .header-subsection .text-wrapper {
    font-size: 16px;
    line-height: 22px;
    padding: 10px 18px;
    width: auto;
  }

  .header-subsection .indicator {
    display: none;
  }
}

</style>
